// extracted by mini-css-extract-plugin
module.exports = {"socialsWrapper":"SocialLinks_socialsWrapper__qhXMN","socialLink":"SocialLinks_socialLink__NbEgS"};